/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowMergeLeft = createReactComponent("outline", "arrow-merge-left", "IconArrowMergeLeft", [["path", { "d": "M8 8l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M12 20v-16", "key": "svg-1" }], ["path", { "d": "M6 18c4 -1.333 6 -4.667 6 -10", "key": "svg-2" }]]);

export { IconArrowMergeLeft as default };
//# sourceMappingURL=IconArrowMergeLeft.mjs.map
